(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Locale', Locale);

    /* @ngInject */
    function Locale ($resource) {
        var resourceUrl =  'api/system/locales/:id';

        return $resource(resourceUrl, {id:'@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
